import * as React from 'react'

export const Loader = () => (
  <>
    <circle cx='84' cy='50' r='0' fill='currentColor'>
      <animate
        attributeName='r'
        values='10;0;0;0;0'
        keyTimes='0;0.25;0.5;0.75;1'
        keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
        calcMode='spline'
        dur='1s'
        repeatCount='indefinite'
        begin='0s'
      />
      <animate
        attributeName='cx'
        values='84;84;84;84;84'
        keyTimes='0;0.25;0.5;0.75;1'
        keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
        calcMode='spline'
        dur='1s'
        repeatCount='indefinite'
        begin='0s'
      />
    </circle>
    <circle cx='84' cy='50' r='3.47843' fill='currentColor'>
      <animate
        attributeName='r'
        values='0;10;10;10;0'
        keyTimes='0;0.25;0.5;0.75;1'
        keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
        calcMode='spline'
        dur='1s'
        repeatCount='indefinite'
        begin='-0.5s'
      />
      <animate
        attributeName='cx'
        values='16;16;50;84;84'
        keyTimes='0;0.25;0.5;0.75;1'
        keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
        calcMode='spline'
        dur='1s'
        repeatCount='indefinite'
        begin='-0.5s'
      />
    </circle>
    <circle cx='72.1733' cy='50' r='10' fill='currentColor'>
      <animate
        attributeName='r'
        values='0;10;10;10;0'
        keyTimes='0;0.25;0.5;0.75;1'
        keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
        calcMode='spline'
        dur='1s'
        repeatCount='indefinite'
        begin='-0.25s'
      />
      <animate
        attributeName='cx'
        values='16;16;50;84;84'
        keyTimes='0;0.25;0.5;0.75;1'
        keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
        calcMode='spline'
        dur='1s'
        repeatCount='indefinite'
        begin='-0.25s'
      />
    </circle>
    <circle cx='38.1733' cy='50' r='10' fill='currentColor'>
      <animate
        attributeName='r'
        values='0;10;10;10;0'
        keyTimes='0;0.25;0.5;0.75;1'
        keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
        calcMode='spline'
        dur='1s'
        repeatCount='indefinite'
        begin='0s'
      />
      <animate
        attributeName='cx'
        values='16;16;50;84;84'
        keyTimes='0;0.25;0.5;0.75;1'
        keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
        calcMode='spline'
        dur='1s'
        repeatCount='indefinite'
        begin='0s'
      />
    </circle>
    <circle cx='16' cy='50' r='6.52157' fill='currentColor'>
      <animate
        attributeName='r'
        values='0;0;10;10;10'
        keyTimes='0;0.25;0.5;0.75;1'
        keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
        calcMode='spline'
        dur='1s'
        repeatCount='indefinite'
        begin='0s'
      />
      <animate
        attributeName='cx'
        values='16;16;16;50;84'
        keyTimes='0;0.25;0.5;0.75;1'
        keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1'
        calcMode='spline'
        dur='1s'
        repeatCount='indefinite'
        begin='0s'
      />
    </circle>
  </>
)
